import { render, staticRenderFns } from "./AutoCorrectionType.vue?vue&type=template&id=3d85ace3&scoped=true&"
import script from "./AutoCorrectionType.vue?vue&type=script&lang=js&"
export * from "./AutoCorrectionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85ace3",
  null
  
)

export default component.exports